import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ExtraExpensesState } from './extra-expenses.state';

export const selectExtraExpensesState = createFeatureSelector<ExtraExpensesState>('adminExtraExpenses');

export const selectAllExpenses = createSelector(
  selectExtraExpensesState,
  (state) => state.expenses,
);

export const selectExtraExpensesLoading = createSelector(
  selectExtraExpensesState,
  (state) => state.loading,
);

export const selectExtraExpensesPagination = createSelector(
  selectExtraExpensesState,
  (state) => ({
    total: state.total,
    page: state.page,
    limit: state.limit,
    totalPages: state.totalPages,
  }),
);

export const selectExtraExpensesParams = createSelector(
  selectExtraExpensesState,
  (state) => state.params,
);

export const selectExtraExpensesError = createSelector(
  selectExtraExpensesState,
  (state) => state.error,
);
